import { User } from '../models/user';
import { Organization } from '../models/organization';
import { UserRole } from '../enums/user-role';


export class UserTools {

  static hasRole(
    user: User,
    organization: Organization,
    role: UserRole,
  ): boolean {
    return user.roles?.includes(`${organization.slug}_${role}`) ?? false;
  }


  static hasAnyRole(
    user: User,
    organization: Organization,
    roles: UserRole[],
  ): boolean {
    return roles.some(role =>
      this.hasRole(user, organization, role)
    );
  }

}
